/**
 * ����������� HTML-������ � DOM-������� � ���������� ������ �������� ������� �������� �������.
 * @param {string} html - HTML-������ ��� �������������� � DOM-�������.
 * @returns {HTMLElement} - DOM-�������, �������������� ������ �������� ������� �������� �������.
 */
export default function html2Element(html) {
    // ������� ������� �������
    var template = document.createElement('template');

    // ������� ������ ������� � ������ � ����� ������ HTML
    html = html.trim();

    // ��������� ���������� ������� HTML-�������
    template.innerHTML = html;

    // ���������� ������ �������� ������� �������� �������
    return template.content.firstChild;
}
